// @flow
import * as React from 'react';
import { getContrastColor } from '../../utils/color.utils';

type Props = {
  types: { [string]: { organizationID: string, color: string, name: string, trash: string } },
  organizations: { [string]: { organizationID: string, organizationName: string } },
  currentOrganizationID: string
};

export default function ActivityTypeHints({ types, organizations, currentOrganizationID }: Props) {
  const visibleTypes = React.useMemo(
    () =>
      Object.values(types).filter(
        ({ organizationID, trash }) => organizationID === currentOrganizationID && trash === '0'
      ),
    [types, currentOrganizationID]
  );

  if (!visibleTypes.length) return null;

  const currentOrg = organizations[currentOrganizationID];

  return (
    <div className="activity-types-hints">
      <div className="activity-types-hint-group">
        {currentOrg && (
          <div className="text-bold activity-type-title">{currentOrg.organizationName}</div>
        )}

        {visibleTypes.map(({ color, name }, idx) => {
          const style = {
            backgroundColor: color,
            color: getContrastColor(color)
          };

          return (
            <div key={`${name}-${idx}`}>
              <span style={style} className="calendar-status">
                <span className="icon plane-earth" /> 12:00 AM <b>JZ</b> #1234
              </span>{' '}
              - {name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
